// @styles 
import './styles.scss'
import { Fade } from 'react-reveal'

export default function Planflex({ data }) {
    return (
        <div className='planflex__container' id={data.primary.idcontent}>
            <div className='container-xl'>
                <div className='planflex__container-content'>
                    {data.primary.sectiontitle && (
                        <Fade left delay={0.3}>
                            <div className='homepage__container-title center-title'>
                                {data.primary.sectiontitle}
                            </div>
                        </Fade>
                    )}
                    <div className='planflex__container-content-cards__container'>
                        {data.items && data.items.length > 0 && data.items.map((item, index) =>
                            <Fade bottom={index == 1 ? true : false} left={index == 0 ? true : false} right={index == 2 ? true : false} delay={0.3}>
                                <div className='planflex__container-content-cards__container__item' key={index}>
                                    <img
                                        src={item.image ? item.image.url : ""}
                                        className='planflex__container-content-cards__container__item-img'
                                        alt={item?.image?.alt}
                                    />
                                    <Fade left delay={0.6}><p className='planflex__container-content-cards__container__item-title'>{item.itemtitle ? item.itemtitle : ""}</p></Fade>
                                    <p className='planflex__container-content-cards__container__item-description'>{item.message ? item.message : ""}</p>
                                </div>
                            </Fade>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}